import React from 'react'
import { inject, observer } from 'mobx-react'
import Icon from 'components/common/Icon'

const ErrorBar = ({ errorStore }) => (
  errorStore.errorMessage === null
    ? null
    : (
      <div className='error-bar'>
        <Icon id='fa-times' onClick={() => errorStore.clear()} />
        <p className='error-message' dangerouslySetInnerHTML={{ __html: errorStore.errorMessage }} />
      </div>
      )
)

export default inject('errorStore')(
  observer(ErrorBar)
)
